export default "/_next/static/fonts/tt_norms_pro_medium-eab8c3227215d0721d7dc91061ba24d7.woff";